export function isIOSDevice(): boolean {
  // https://github.com/paperlesspost/paperless-post/blob/master/app/javascripts/detect.js#L44
  return !!getUserAgent().match(/i(Phone|Pad|Pod)/);
}

export function getUserAgent(): string {
  return (
    (typeof window !== 'undefined' &&
      window.navigator &&
      window.navigator.userAgent) ||
    ''
  );
}

export function convertRemToPixels(rem: number) {
  if (document.documentElement) {
    return (
      rem * parseInt(getComputedStyle(document.documentElement).fontSize, 10) ||
      0
    );
  }
}
